<div class="ui-g">
  <div class="ui-g-12 top-search" style="padding: 0px;">
    <div class="ui-inputgroup">
      <!-- <span class="ui-inputgroup-addon" style="padding: 6px;color: black;width: 74px;height: 34px;">Search</span> -->
      <label for="search-field" class="visuallyHidden">Search matches will be displayed below the field</label>
      <p-autoComplete name="search-field" id="search-field" aria-label="Search using table values" class="ui-g-12" [(ngModel)]="searchInput" 
        field="header" [suggestions]="suggestions" (completeMethod)="autoSuggestSearch($event)" placeholder="Search"></p-autoComplete>
      <span class="visuallyHidden" role="status" aria-live="assertive">{{suggestions.length}} results found, use arrow keys to navigate</span>

      <span class="ui-inputgroup-addon" (click)="search()" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Apply Search" 
        style="padding-top: 2px;padding-bottom: 0px;cursor: pointer; border-right: 0 !important;">
        <span class="search-icon custom-icon"></span>
      </span>
      
      <span class="ui-inputgroup-addon" (click)="clear()" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Clear Search" 
        style="padding-top: 7px;color: black;"><i class="pi pi-times-circle circle-delete" title="Clear"></i></span>
    </div>
  </div>
</div>

